import React from "react";
import user   from "../assets/images/user.png";
import video from "../assets/images/Rectangle 18156.png";
import { PiTranslateBold } from 'react-icons/pi';
import { FaPlay } from "react-icons/fa6";

const SpecificFileAudioView = () => {
  return (
    <>
      <div className="flex justify-between">
        <div className="flex gap-2">
          <img className="w-4 h-4 rounded-full" src={user} alt="user" />
          <p className="text-[#0F0C18] text-xs font-medium tracking-tight">Andrew Wack</p>
          <p className="text-[#9392A2] text-xs font-medium tracking-tight">24 Mb</p>
        </div>
        <div className="flex gap-2">
          <PiTranslateBold />
          <p className="text-[#9392A2] text-xs font-medium tracking-tight">English</p>
        </div>
      </div>
      <div className="flex justify-center py-3">
        <img className="w-[500px] h-[400px]" src={video} alt="video" />
      </div>
      <input type="range" className="w-full" />
      <div className="flex justify-center my-3">
        <div className="w-14 h-14 rounded-full text-white bg-[#2A2A36] flex items-center justify-center cursor-pointer">
          <FaPlay className="text-sm" />
        </div>
      </div>
    </>
  );
};

export default SpecificFileAudioView;